import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import translations from '../translations';

function Contact({ language = 'en' }) {
  const t = translations[language] || translations['en'];
  const ct = t.contact || translations['en'].contact;

  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error

  useEffect(() => {
    document.title = 'Contact | ERC Unlock';
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');

    const body = new URLSearchParams({
      'form-name': 'contact',
      ...formData,
    });

    try {
      const res = await fetch('/', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body.toString() });
      if (res.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  const inputStyle = {
    width: '100%', padding: '10px 14px', border: '1.5px solid var(--border)',
    borderRadius: 10, fontFamily: 'inherit', fontSize: 14, color: 'var(--text)',
    background: 'white', boxSizing: 'border-box', marginTop: 6, outline: 'none',
    transition: 'border-color .2s',
  };

  const labelStyle = { display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 14 };

  return (
    <Layout language={language}>
      <div className="content-card" style={{ maxWidth: 640 }}>
        <h1>{ct.title}</h1>
        <p className="subtitle">{ct.subtitle}</p>

        {status === 'success' ? (
          <div style={{ marginTop: 32, background: '#f0fdf4', border: '2px solid #bbf7d0', borderRadius: 12, padding: '24px 28px', textAlign: 'center' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>✅</div>
            <h3 style={{ margin: '0 0 8px', color: '#15803d' }}>{ct.successTitle}</h3>
            <p style={{ margin: 0, color: '#166534', fontSize: 14 }}>{ct.successMessage}</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} name="contact" method="POST" data-netlify="true" style={{ marginTop: 28 }}>
            <input type="hidden" name="form-name" value="contact" />
            <p style={{ display: 'none' }}><input name="bot-field" /></p>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <label style={labelStyle}>
                {ct.nameLabel}
                <input style={inputStyle} type="text" name="name" value={formData.name} onChange={handleChange} placeholder={ct.namePlaceholder} required />
              </label>
              <label style={labelStyle}>
                {ct.emailLabel}
                <input style={inputStyle} type="email" name="email" value={formData.email} onChange={handleChange} placeholder={ct.emailPlaceholder} required />
              </label>
            </div>

            <label style={labelStyle}>
              {ct.subjectLabel}
              <input style={inputStyle} type="text" name="subject" value={formData.subject} onChange={handleChange} placeholder={ct.subjectPlaceholder} required />
            </label>

            <label style={labelStyle}>
              {ct.messageLabel}
              <textarea
                style={{ ...inputStyle, minHeight: 140, resize: 'vertical', lineHeight: 1.6 }}
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder={ct.messagePlaceholder}
                required
              />
            </label>

            {status === 'error' && (
              <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 10, padding: '10px 14px', color: '#dc2626', fontSize: 13, marginBottom: 14 }}>
                {ct.errorMessage}
              </div>
            )}

            <button
              type="submit"
              disabled={status === 'submitting'}
              style={{ width: '100%', padding: '14px', background: status === 'submitting' ? '#6b7280' : 'var(--primary)', color: 'white', border: 'none', borderRadius: 12, fontSize: 15, fontWeight: 700, cursor: status === 'submitting' ? 'not-allowed' : 'pointer', fontFamily: 'inherit' }}
            >
              {status === 'submitting' ? ct.submitting : ct.submitButton}
            </button>
          </form>
        )}
      </div>
    </Layout>
  );
}

export default Contact;
